import AddSubscription from "components/Modals/AddSubscription";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteSubscriptionPlanRequest,
  getSubscriptionsPlanRequest,
} from "store/actions";
import ConfirmModal from "./ConfirmModal";
import { useHistory } from "react-router-dom";
import OwnerSelector from "components/OwnerSelector";
import { FormGroup, Label } from "reactstrap";
import moment from "moment";

const Subscriptionplan = (props) => {
  const { loading, subscriptionPlans } = useSelector(
    ({ Subscriptions }) => Subscriptions
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    userId: null,
  });
  const [selectedCollection, setSelectedCollection] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [actionType, setActionType] = useState(null);

  useEffect(() => {
    dispatch(getSubscriptionsPlanRequest({ page: 1, limit: 100, order: -1 }));
  }, []);
  const onEditHandler = (row) => {
    setRowData(row);
    setShowAddModal(true);
    setActionType("edit_data")
  };

  const onFinishAddEditSub = () => {
    dispatch(getSubscriptionsPlanRequest({ page: 1, limit: 100 }));
  };

  const toggleConfirmModal = (userId) => {
    setConfirmModal((prevState) => ({ isOpen: !prevState.isOpen, userId }));
  };

  const removeConfirm = () => {
    const { userId, isOpen } = confirmModal;

    const onComplete = () => {
      dispatch(getSubscriptionsPlanRequest({ page: 1, limit: 100 }));
    };

    setConfirmModal({ isOpen: !isOpen, userId: null });
    dispatch(deleteSubscriptionPlanRequest({ _id: userId }, onComplete));
  };

  const onChangeCollectionFilter = (data) => {

    setSelectedCollection(data);

    dispatch(getSubscriptionsPlanRequest({ page: 1, limit: 100, ownerId: data?.value }));
  };

  return (
    <section className="Subscriptionplan_main">
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        toggle={toggleConfirmModal}
        onConfirm={removeConfirm}
      />
      {showAddModal && (
        <AddSubscription
          data={actionType === "edit_data" ? rowData : null}
          show={showAddModal}
          onFinish={() => onFinishAddEditSub()}
          onhide={() => setShowAddModal(false)}
          actionType={actionType}
        />
      )}
      <Container fluid>
        <Row className="">
          {/* <Col lg={4}>{props.t("subscriptions")}</Col> */}
          <Col lg={4}></Col>
          <Col lg={4}>
            {" "}
            <FormGroup>
              <Label for="exampleEmail">{props.t("Owners")}</Label>
              {/* <Input
                    type="select"
                    name="parkingId"
                    id="exampleEmail"
                    value={fields.parkingId}
                    // placeholder="BG"
                    onChange={onFieldsChange}
                  /> */}
              <OwnerSelector
                placeholder="select owner"
                isMulti={false}
                defaultSelected={selectedCollection}
                onChangeHandler={onChangeCollectionFilter}
              />
            </FormGroup>
          </Col>
          <Col lg={4}>
            <div className="btn_align" onClick={() => setActionType("add_data")}>
              <Button
                className="btn-success"
                onClick={() => setShowAddModal(true)}
              >
                {props.t("add")} {props.t("subscriptions")}
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          {subscriptionPlans?.slice()?.reverse()?.map((plan) => {
            return (
              <Col key={plan?._id} lg={4} md={6} sm={12}>
                <div className="card_coommnsub monthly_Card my-3">
                  <div className="d-flex justify-content-end cursor-pointer">
                    <svg
                      onClick={() => toggleConfirmModal(plan?._id)}
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_20_1145)">
                        <path
                          d="M3.24396 4.09766V18.1464C3.24396 18.5604 3.40842 18.9575 3.70116 19.2502C3.9939 19.543 4.39094 19.7074 4.80493 19.7074H17.2927C17.7067 19.7074 18.1038 19.543 18.3965 19.2502C18.6893 18.9575 18.8537 18.5604 18.8537 18.1464V4.09766H3.24396ZM7.92688 16.1952C7.92688 16.2987 7.88577 16.398 7.81258 16.4712C7.7394 16.5443 7.64014 16.5855 7.53664 16.5855H6.75615C6.65265 16.5855 6.55339 16.5443 6.48021 16.4712C6.40702 16.398 6.36591 16.2987 6.36591 16.1952V7.60985C6.36591 7.50635 6.40702 7.40709 6.48021 7.33391C6.55339 7.26072 6.65265 7.21961 6.75615 7.21961H7.53664C7.64014 7.21961 7.7394 7.26072 7.81258 7.33391C7.88577 7.40709 7.92688 7.50635 7.92688 7.60985V16.1952ZM11.8293 16.1952C11.8293 16.2987 11.7882 16.398 11.715 16.4712C11.6418 16.5443 11.5426 16.5855 11.4391 16.5855H10.6586C10.5551 16.5855 10.4558 16.5443 10.3826 16.4712C10.3095 16.398 10.2683 16.2987 10.2683 16.1952V7.60985C10.2683 7.50635 10.3095 7.40709 10.3826 7.33391C10.4558 7.26072 10.5551 7.21961 10.6586 7.21961H11.4391C11.5426 7.21961 11.6418 7.26072 11.715 7.33391C11.7882 7.40709 11.8293 7.50635 11.8293 7.60985V16.1952ZM15.7318 16.1952C15.7318 16.2987 15.6906 16.398 15.6175 16.4712C15.5443 16.5443 15.445 16.5855 15.3415 16.5855H14.561C14.4575 16.5855 14.3583 16.5443 14.2851 16.4712C14.2119 16.398 14.1708 16.2987 14.1708 16.1952V7.60985C14.1708 7.50635 14.2119 7.40709 14.2851 7.33391C14.3583 7.26072 14.4575 7.21961 14.561 7.21961H15.3415C15.445 7.21961 15.5443 7.26072 15.6175 7.33391C15.6906 7.40709 15.7318 7.50635 15.7318 7.60985V16.1952Z"
                          fill="#F16573"
                        />
                        <path
                          d="M15.3727 6.82959H14.5298C14.4177 6.82959 14.3101 6.87386 14.2304 6.95279C14.1507 7.03172 14.1055 7.13892 14.1044 7.25105V16.5545C14.1055 16.6666 14.1507 16.7738 14.2304 16.8527C14.3101 16.9317 14.4177 16.9759 14.5298 16.9759H15.3727C15.4849 16.9759 15.5925 16.9317 15.6721 16.8527C15.7518 16.7738 15.7971 16.6666 15.7981 16.5545V7.25105C15.7971 7.13892 15.7518 7.03172 15.6721 6.95279C15.5925 6.87386 15.4849 6.82959 15.3727 6.82959ZM15.7318 16.1954C15.7318 16.2989 15.6906 16.3982 15.6175 16.4714C15.5443 16.5446 15.445 16.5857 15.3415 16.5857H14.561C14.4575 16.5857 14.3583 16.5446 14.2851 16.4714C14.2119 16.3982 14.1708 16.2989 14.1708 16.1954V7.61008C14.1708 7.50658 14.2119 7.40732 14.2851 7.33413C14.3583 7.26095 14.4575 7.21983 14.561 7.21983H15.3415C15.445 7.21983 15.5443 7.26095 15.6175 7.33413C15.6906 7.40732 15.7318 7.50658 15.7318 7.61008V16.1954ZM11.4391 6.82959H10.5961C10.484 6.82959 10.3764 6.87386 10.2967 6.95279C10.2171 7.03172 10.1718 7.13892 10.1708 7.25105V16.5545C10.1718 16.6666 10.2171 16.7738 10.2967 16.8527C10.3764 16.9317 10.484 16.9759 10.5961 16.9759H11.4391C11.5512 16.9759 11.6588 16.9317 11.7385 16.8527C11.8181 16.7738 11.8634 16.6666 11.8644 16.5545V7.25105C11.8634 7.13892 11.8181 7.03172 11.7385 6.95279C11.6588 6.87386 11.5512 6.82959 11.4391 6.82959ZM11.7981 16.1954C11.7981 16.2989 11.757 16.3982 11.6838 16.4714C11.6106 16.5446 11.5114 16.5857 11.4079 16.5857H10.6274C10.5239 16.5857 10.4246 16.5446 10.3514 16.4714C10.2782 16.3982 10.2371 16.2989 10.2371 16.1954V7.61008C10.2371 7.50658 10.2782 7.40732 10.3514 7.33413C10.4246 7.26095 10.5239 7.21983 10.6274 7.21983H11.4079C11.5114 7.21983 11.6106 7.26095 11.6838 7.33413C11.757 7.40732 11.7981 7.50658 11.7981 7.61008V16.1954ZM7.50541 6.82959H6.66249C6.55035 6.82959 6.44274 6.87386 6.36308 6.95279C6.28342 7.03172 6.23815 7.13892 6.23712 7.25105V16.5545C6.23815 16.6666 6.28342 16.7738 6.36308 16.8527C6.44274 16.9317 6.55035 16.9759 6.66249 16.9759H7.50541C7.61756 16.9759 7.72516 16.9317 7.80482 16.8527C7.88448 16.7738 7.92975 16.6666 7.93078 16.5545V7.25105C7.92975 7.13892 7.88448 7.03172 7.80482 6.95279C7.72516 6.87386 7.61756 6.82959 7.50541 6.82959ZM7.86444 16.1954C7.86444 16.2989 7.82332 16.3982 7.75014 16.4714C7.67695 16.5446 7.57769 16.5857 7.47419 16.5857H6.69371C6.59021 16.5857 6.49095 16.5446 6.41776 16.4714C6.34458 16.3982 6.30346 16.2989 6.30346 16.1954V7.61008C6.30346 7.50658 6.34458 7.40732 6.41776 7.33413C6.49095 7.26095 6.59021 7.21983 6.69371 7.21983H7.47419C7.57769 7.21983 7.67695 7.26095 7.75014 7.33413C7.82332 7.40732 7.86444 7.50658 7.86444 7.61008V16.1954Z"
                          fill="#DB5669"
                        />
                        <path
                          d="M11.0488 4.09766L16.2082 4.67092C16.3991 4.69215 16.5755 4.78303 16.7036 4.92616C16.8317 5.0693 16.9025 5.25465 16.9025 5.44673V19.7074H17.2927C17.7067 19.7074 18.1038 19.543 18.3965 19.2502C18.6892 18.9575 18.8537 18.5604 18.8537 18.1464V4.09766H11.0488Z"
                          fill="#DB5669"
                        />
                        <path
                          d="M10.6586 4.09766L4.80493 4.74819V19.7074C4.39094 19.7074 3.9939 19.543 3.70116 19.2502C3.40842 18.9575 3.24396 18.5604 3.24396 18.1464V4.09766H10.6586Z"
                          fill="#F97A8D"
                        />
                        <path
                          d="M8.70734 0.195312H13.3903C13.8043 0.195313 14.2013 0.359772 14.494 0.652512C14.7868 0.945252 14.9512 1.34229 14.9512 1.75629V2.53678H7.14636V1.75629C7.14636 1.34229 7.31082 0.945252 7.60356 0.652512C7.8963 0.359772 8.29334 0.195313 8.70734 0.195312Z"
                          fill="#374F68"
                        />
                        <path
                          d="M1.29271 2.53662H20.4147C20.5182 2.53662 20.6174 2.57774 20.6906 2.65092C20.7638 2.72411 20.8049 2.82337 20.8049 2.92687V3.70735C20.8049 3.81085 20.7638 3.91011 20.6906 3.9833C20.6174 4.05648 20.5182 4.0976 20.4147 4.0976H1.29271C1.18921 4.0976 1.08995 4.05648 1.01677 3.9833C0.943581 3.91011 0.902466 3.81085 0.902466 3.70735V2.92687C0.902466 2.82337 0.943581 2.72411 1.01677 2.65092C1.08995 2.57774 1.18921 2.53662 1.29271 2.53662Z"
                          fill="#30455C"
                        />
                        <path
                          d="M20.8049 2.92687H1.68295C1.57945 2.92687 1.48019 2.96798 1.40701 3.04116C1.33382 3.11435 1.29271 3.21361 1.29271 3.31711V4.0976C1.18921 4.0976 1.08995 4.05648 1.01677 3.9833C0.943581 3.91011 0.902466 3.81085 0.902466 3.70735V2.92687C0.902466 2.82337 0.943581 2.72411 1.01677 2.65092C1.08995 2.57774 1.18921 2.53662 1.29271 2.53662H20.4147C20.5182 2.53662 20.6174 2.57774 20.6906 2.65092C20.7638 2.72411 20.8049 2.82337 20.8049 2.92687Z"
                          fill="#374F68"
                        />
                        <path
                          d="M9.48783 0.585556H14.1sss708C14.2652 0.584776 14.3592 0.593752 14.4517 0.612874C14.163 0.345167 13.784 0.196077 13.3903 0.195312L8.70734 0.195313C8.29334 0.195313 7.8963 0.359772 7.60356 0.652512C7.31082 0.945252 7.14636 1.34229 7.14636 1.75629V2.53678H11.8293L9.00705 2.25463C8.84882 2.23927 8.69906 2.17597 8.5778 2.07318C8.45653 1.9704 8.36955 1.83303 8.32847 1.67947C8.28739 1.5259 8.29419 1.36345 8.34795 1.21385C8.40171 1.06425 8.49986 0.934635 8.62929 0.842337C8.88405 0.674316 9.18264 0.585011 9.48783 0.585556Z"
                          fill="#46617A"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_20_1145">
                          <rect
                            width="19.9024"
                            height="19.9024"
                            fill="white"
                            transform="translate(0.902466)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h5><b>Parking Name:</b> {plan?.parkingId?.building_name}</h5>
                  <div>
                    <b>Plan Name:</b> {plan?.name}
                  </div>
                  <div><b>Type:</b> {plan?.type == 'month' ? "Monthly" : "Yearly"}</div>
                  <div><b>Duration(in {plan?.type}):</b> {plan?.duration}</div>
                  <div><b>Price:</b> €{plan?.price}</div>
                  <div><b>Create At:</b> {moment(plan?.createdAt).format('MMMM Do YYYY')}</div>
                  <div><b>Expire At:</b> {moment(plan?.createdAt).add(plan?.duration, plan?.type == 'month' ? 'months' : 'years').format('MMMM Do YYYY')}</div>

                  <p
                    dangerouslySetInnerHTML={{ __html: plan?.description }}
                  ></p>
                  <Button
                    className="btn_card_comon month_red"
                    onClick={() => onEditHandler(plan)}
                  >
                    {props.t("edit")}
                  </Button>
                </div>
              </Col>
            );
          })}
        </Row>

        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className="latest_table_inner">
              <h2 class="fillter_head pl-2 my-4">
                {props.t("plan")} {props.t("details")}
              </h2>

              <div className="subscription-plans-table-wrap">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>
                        <b>{props.t("plan")}</b>
                      </th>
                      <th>
                        <b>
                          {props.t("plan")} {props.t("type")}
                        </b>
                      </th>
                      <th>
                        <b>{props.t("amount")}</b>
                      </th>
                      <th>
                        <b>
                          {props.t("created")} {props.t("date")}
                        </b>
                      </th>
                      {/* <th>
                        <b>
                          {props.t("modified")} {props.t("date")}
                        </b>
                      </th>
                      <th>
                        <b>{props.t("subscribed")}</b>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {(subscriptionPlans || [])?.slice()?.reverse()?.map((item) => {
                      console.log(item, "*******");
                      return (
                        <tr>
                          <td>{item?.name}</td>
                          <td>{item?.type}</td>
                          <td>{item?.price}</td>
                          <td>{moment(item?.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</td>
                          {/* <td></td>
                          <td>
                            <Button
                              onClick={() =>
                                history.push(
                                  `/subscription/${item?._id}/companies`
                                )
                              }
                            >
                              {item?.users?.length} {props.t("users")}
                            </Button>
                          </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default withTranslation()(Subscriptionplan);
